// src/utils/getSuggestedCurrency.ts

export const symbolFor = (cur: string) =>
  cur === 'EUR'
    ? '€'
    : cur === 'USD'
    ? '$'
    : cur === 'JPY'
    ? '¥'
    : cur === 'GBP'
    ? '£'
    : cur === 'QAR'
    ? 'ر.ق'
    : cur;


export const getSuggestedCurrency = async (): Promise<string> => {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const { country_code } = await res.json();

    const map: Record<string, string> = {
      US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD',  // dólar, dólar can., libra, dólar aus.
      AE: 'AED', JP: 'JPY', CN: 'CNY', CH: 'CHF',  // dirham, yen, yuan, franco
      QA: 'QAR', //Rial Catarí
    };
    return map[country_code] ?? 'EUR';
  } catch {
    return 'EUR';
  }
};
